import { CURATED_LLMS } from '../../data/arenaModels'

// Models cycled through the hero's "now serving" ticker. Derived from the same
// CURATED_LLMS list the /models page's language-model table renders, so the
// ticker always matches what that section shows — no separate name list to
// keep in sync. LLMs only, not CURATED_IMAGE/VISION/VOICE: "Unlimited
// context. Unlimited tokens." is a token-generation claim that doesn't fit
// an image or voice model the same way. The ticker only needs a display name
// plus presentation (dot color + subline); the rest of each model's data
// lives in data/arenaModels.js.
const HERO_SUB = 'Unlimited context. Unlimited tokens.'

// Dot colors, cycled by position — kept within the site's blue/neutral palette.
const DOT_COLORS = ['#93A9FF', '#d7d7d7', '#e8e8e8', '#4d6bfe', '#5B8CFF', '#cfcfcf']

export const HERO_MODELS = CURATED_LLMS.map((m, i) => ({
  name: m.model,
  sub: HERO_SUB,
  color: DOT_COLORS[i % DOT_COLORS.length],
  // Mirrors the model's "Coming soon" state on /models, so the ticker label
  // reads COMING SOON instead of NOW SERVING for not-yet-live models.
  soon: Boolean(m.soon),
}))
